export const DropdownIconThin = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.4277 5.78516L8.99916 11.5709L2.57059 5.78515" stroke="#191B1F" strokeWidth="1.5" />
  </svg>
);
